import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

const SlideImagePage = () => {
  const [Slides, setSlides] = useState([]);
  const [numImages, setNumImages] = useState(1);
  const [imageFiles, setImageFiles] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editFile, setEditFile] = useState(null);
  const fetchSlides = async () => {
    try {
      const res = await fetch("https://apii.agrivemart.com/api/Slide/");
      const data = await res.json();
      setSlides(data);
    } catch (err) {
      console.error("Error fetching Slides:", err);
    }
  };

  useEffect(() => {
    fetchSlides();
  }, []);

  // Handle file change
  const handleFileChange = (e, index) => {
    const files = [...imageFiles];
    files[index] = e.target.files[0];
    setImageFiles(files);
  };
  const handleUpload = async () => {
    if (imageFiles.length === 0) return alert("Please select images");

    const formData = new FormData();
    imageFiles.forEach((file) => {
      if (file) formData.append("image", file);
    });

    try {
      const token = localStorage.getItem("authToken");
      const res = await fetch(
        "https://apii.agrivemart.com/api/Slide/",
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        }
      );
      if (res.ok) {
        alert("Slides uploaded successfully");
        setImageFiles([]);
        setNumImages(1);
        fetchSlides();
      } else {
        alert("Failed to upload Slides");
      }
    } catch (err) {
      console.error(err);
      alert("Network error");
    }
  };
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Slide?")) return;
    try {
      const token = localStorage.getItem("authToken");
      const res = await fetch(
        `https://apii.agrivemart.com/api/Slide/${id}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.ok) {
        alert("Slide deleted successfully");
        fetchSlides();
      } else {
        alert("Failed to delete Slide");
      }
    } catch (err) {
      console.error(err);
      alert("Network error");
    }
  };
  const handleUpdate = async () => {
    if (!editId || !editFile) return alert("Select a new image to update");
    const formData = new FormData();
    formData.append("image", editFile);

    try {
      const token = localStorage.getItem("authToken");
      const res = await fetch(
        `https://apii.agrivemart.com/api/Slide/${editId}`,
        {
          method: "PUT",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        }
      );
      if (res.ok) {
        alert("Deak updated successfully");
        setEditId(null);
        setEditFile(null);
        fetchSlides();
      } else {
        alert("Failed to update Slide");
      }
    } catch (err) {
      console.error(err);
      alert("Network error");
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Slide Image Management
      </Typography>
      <FormControl fullWidth margin="normal">
        <InputLabel>Number of Images</InputLabel>
        <Select
          value={numImages}
          onChange={(e) => {
            setNumImages(Number(e.target.value));
            setImageFiles(Array(Number(e.target.value)).fill(null));
          }}
        >
          {[...Array(10).keys()].map((i) => (
            <MenuItem key={i + 1} value={i + 1}>
              {i + 1}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* File inputs */}
      {Array.from({ length: numImages }).map((_, idx) => (
        <Box key={idx} sx={{ mb: 2 }}>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, idx)}
          />
        </Box>
      ))}

      <Button
        variant="contained"
        color="success"
        onClick={handleUpload}
        sx={{ mb: 3 }}
      >
        Upload Slides
      </Button>
      {Slides.length > 0 && (
        <Box>
          <Typography variant="h6">Existing Slides</Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2 }}>
            {Slides.map((Slide) => (
              <Box key={Slide._id} sx={{ position: "relative" }}>
                <img
                  src={`https://apii.agrivemart.com/uploads/slide/${Slide.filename}`}
                  alt="Slide"
                  style={{
                    width: 200,
                    height: 120,
                    objectFit: "cover",
                    borderRadius: 4,
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 0.5,
                  }}
                >
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => setEditId(Slide._id)}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => handleDelete(Slide._id)}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
                {editId === Slide._id && (
                  <Box sx={{ mt: 1 }}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => setEditFile(e.target.files[0])}
                    />
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={handleUpdate}
                      sx={{ mt: 1 }}
                    >
                      Update
                    </Button>
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SlideImagePage;
